var Industry = "الصناعة";
var Aerospace = "الفضاء الجوي";
var Agriculture = "الزراعة";
var Automotive = "السيارات";
var Education = "التعليم";
var Gaming = "الألعاب";
var Government = "الحكومة";
var Healthcare = "الرعاية الصحية";
var Hospitality = "الضيافة";
var Manufacturing = "التصنيع";
var Mining = "التعدين";
var Other = "أخرى";
var Retail = "البيع بالتجزئة";
var Telecommunications = "الاتصالات";
var Travel = "السفر";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "الكمبيوتر والأجهزة الإلكترونية",
	"Consumer goods": "السلع الاستهلاكية",
	Education: Education,
	"Financial services": "الخدمات المالية",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "علوم الحياة",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "التسويق والإعلان",
	"Media & entertainment": "الإعلام والترفيه",
	Mining: Mining,
	"Non-profit organization": "المؤسسات غير الربحية",
	"Oil & gas": "النفط والغاز",
	Other: Other,
	"Power & utilities": "الكهرباء والمرافق العامة",
	"Professional services": "الخدمات المهنية",
	"Real estate & construction": "العقارات والإنشاءات",
	Retail: Retail,
	"Software & internet": "البرامج والإنترنت",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "النقل واللوجستيات",
	Travel: Travel,
	"Wholesale & distribution": "البيع بالجملة والتوزيع"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
